export default function() {
    this.loadSurveys()
}
